import { useSelector } from "react-redux";

import addDotsToPrice from "../price-format";
import CheckoutBillItem from "./checkoutBillItem";

const CheckoutBill = () => {
  const { items, totalPrice } = useSelector((state) => state.cart);

  return (
    <div className="Co_Bill_Wrap">
      <h4>Thông tin đơn hàng</h4>
      {items.map((item, id) => (
        <CheckoutBillItem key={id} item={item} />
      ))}
      <p className="Co_Bill">
        <span>TỔNG</span>
        <span className="text-danger">{addDotsToPrice(totalPrice)}</span>
      </p>
    </div>
  );
};

export default CheckoutBill;
